import Connection from './connection'
import Store from './store'

// This class is just used to create orders. It's called "provision" for some unknown legacy reason.
export default class Provision extends Store {
  constructor(scope) {
    super(new Connection('provisioning', scope))
  }
}



// WEBPACK FOOTER //
// client/stores/provision.js